import { Component, input, output } from '@angular/core';

import { getSpecificOfferValueFromOffer } from '../utils';

@Component({
  selector: 'wl-variable-offer-card',
  templateUrl: './variable-offer-card.component.html',
  styleUrls: ['./variable-offer-card.component.essent.scss'],
})
export class VariableOfferCardComponent {
  readonly title = input<string>();
  readonly description = input<string>();
  readonly buttonTitle = input<string>();
  readonly explanationButtonTitle = input<string>();

  readonly isBestChoice = input(false);

  showExplanation = output<ReturnType<typeof getSpecificOfferValueFromOffer>>();
  selectOffer = output();
}
